const Status: { [key: string]: string } = Object.freeze({
  Solicitada: '0',
  'Em Atendimento': '1',
  Encaminhada: '2',
  Finalizada: '3',
});

export default Status;
